// extracted by mini-css-extract-plugin
export default {"breadcrumbs_new_portal_header":"DataListItem__breadcrumbs_new_portal_header--2vqM_"};